/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "./index.css";
import ContactModal from "../../ContactSales";
import GlueLogo from "../../glueLogo";
import { Link } from "react-router-dom";

export default function SalesContact() {
    const [form, setForm] = useState({
        name: "",
        company: "",
        title: "",
        email: "",
        phone: "",
        notes: "",
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    // VALIDATION
    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const validatePhone = (phone) => {
        const cleaned = phone.replace(/\D/g, "");
        return cleaned.length >= 10;
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });

        // remove error while typing
        setErrors({
            ...errors,
            [e.target.name]: "",
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};

        if (!form.name.trim()) {
            newErrors.name = "Name is required";
        }

        if (!form.company.trim()) {
            newErrors.company = "Company is required";
        }

        if (!form.title.trim()) {
            newErrors.title = "Title is required";
        }

        if (!validateEmail(form.email)) {
            newErrors.email = "Please enter a valid email";
        }

        if (!validatePhone(form.phone)) {
            newErrors.phone = "Enter a valid phone number";
        }

        if (!form.notes.trim()) {
            newErrors.notes = "Please enter your message";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        setLoading(true);
        setSuccess(false);

        try {
            const res = await fetch(
                "https://5549ucvkb3.execute-api.us-east-2.amazonaws.com",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        action: "contactForm",
                        name: form.name,
                        company: form.company,
                        title: form.title,
                        email: form.email,
                        phone: form.phone,
                        message: form.notes,
                    }),
                }
            );

            const data = await res.json();

            if (data.success) {
                setSuccess(true);

                setForm({
                    name: "",
                    company: "",
                    title: "",
                    email: "",
                    phone: "",
                    notes: "",
                });

                setErrors({});
            } else {
                alert("Failed to send message");
            }
        } catch (err) {
            console.error("Error:", err);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="sc-container">

            <header className="navbar">
                <Link to="/" style={{ textDecoration: "none" }}>
                    <div className="navbar-links">
                        <div className="logo">
                            <GlueLogo />
                        </div>

                        <nav className="nav-links">
                            <a href="#demo">Demo</a>
                            <a href="#team">Team</a>

                            <Link
                                to="/help"
                                style={{ textDecoration: "none" }}
                            >
                                <a className="login">Help</a>
                            </Link>

                            <Link
                                to="/sales"
                                style={{ textDecoration: "none" }}
                            >
                                <a className="login" href="#pricing">
                                    Pricing
                                </a>
                            </Link>
                        </nav>
                    </div>
                </Link>

                <div className="actions">

                    <a
                        className="btn-primary-link"
                        href="https://datahub.glueid.com"
                    >
                        Login
                    </a>
                    <ContactModal triggerClass="btn-outline" />
                    <a
                        className="btn-primary-link"
                        href="https://datahub.glueid.com/signup"
                    >
                        Sign Up
                    </a>
                </div>
            </header>

            <div className="sc-wrapper">

                {/* LEFT */}
                <div className="sc-left">
                    <h1>Let’s start the conversation.</h1>

                    <p>
                        Tell us a bit about your organization, and we’ll connect you with the appropriate member of the  GLUE ID team. Whether you’re evaluating solutions, planning an initiative, or ready to move forward, we’ll help you determine the right next step
                    </p>

                    <p>
                        You’re also welcome to create a free account using the signup button in the upper right corner to explore  <a
                            href="https://datahub.glueid.com"
                            style={{ textDecoration: 'none' , color:'#2A3C7B' }}
                        >
                            <strong>GLUE ID</strong>
                        </a>  at your own pace.
                    </p>

                    <p className="sc-highlight">
                        We’ll follow up promptly.
                    </p>
                </div>

                {/* RIGHT */}
                <form className="sc-form" onSubmit={handleSubmit} noValidate>

                    <div className="sc-grid">

                        <Input
                            label="Name"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            error={errors.name}
                        />

                        <Input
                            label="Company"
                            name="company"
                            value={form.company}
                            onChange={handleChange}
                            error={errors.company}
                        />

                        <Input
                            label="Title"
                            name="title"
                            value={form.title}
                            onChange={handleChange}
                            error={errors.title}
                        />

                        <Input
                            label="Email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            error={errors.email}
                        />

                        <Input
                            label="Phone"
                            name="phone"
                            value={form.phone}
                            onChange={handleChange}
                            error={errors.phone}
                        />
                    </div>

                    <div className="sc-textarea">
                        <label>How can we help?</label>

                        <textarea
                            name="notes"
                            placeholder="Share your goals, timeline, or where you are in your process..."
                            value={form.notes}
                            onChange={handleChange}
                        />

                        {errors.notes && (
                            <span className="error-text">
                                {errors.notes}
                            </span>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="sc-btn"
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Get GLUE ID"}
                    </button>

                    {success && (
                        <p
                            style={{
                                color: "green",
                                marginTop: "14px",
                                fontWeight: 500,
                            }}
                        >
                            ✅ Message sent successfully!
                        </p>
                    )}
                </form>
            </div>
        </div>
    );
}

function Input({
    label,
    name,
    value,
    onChange,
    error,
}) {
    return (
        <div className="sc-input">
            <input
                type="text"
                name={name}
                value={value}
                onChange={onChange}
                placeholder=" "
                required
            />

            <label>{label}</label>

            {error && (
                <span className="error-text">
                    {error}
                </span>
            )}
        </div>
    );
}